/**
 * Wildlife Form Dropdown Options
 * Standardized options for wildlife report forms
 */

export const SPECIES_OPTIONS = [
  'No Animal Observation',
  'Mountain Goat',
  'Mountain Caribou',
  'Moose',
  'Elk',
  'Mule Deer',
  'White-tailed Deer',
  'Grizzly Bear',
  'Wolf',
  'Wolverine',
  'Cougar',
  'Coyote',
  'Flying Squirrel'
];

export const UTM_ZONE_OPTIONS = [
  '7',
  '8',
  '9',
  '10',
  '11'
];

export const ANIMAL_DISTANCE_OPTIONS = [
  'Under 100m',
  '100m-500m',
  '500m-1000m',
  'Over 1000m'
];

export const ASPECT_OF_ANIMAL_OPTIONS = [
  'N',
  'E',
  'S',
  'W',
  'FLT'
];

export const ELEVATION_OPTIONS = [
  'Alpine',
  'Treeline',
  'Below Treeline'
];

export const ANIMAL_REACTION_OPTIONS = [
  'No Overt Response',
  'Unconcerned',
  'Curious',
  'Concerned',
  'Alarmed',
  'Very Alarmed – Fled',
  'None'
];

export const ACTION_OPTIONS = [
  'Close Run (CR)',
  'Alert – Other Guides (AL)',
  'Changed Helicopter flight path (CP)',
  'Changed pick-up, landing (CL)',
  'Avoided Run (AR)',
  'Avoided Drainage (AD)',
  'Altered Ski Program (ASP)',
  'No Action Required'
];

export const INVENTORY_METHOD_OPTIONS = [
  'Flight (FL)',
  'Skiing (SKI)'
];

export const MACHINE_TYPE_OPTIONS = [
  'Light (A-Star, B206, B407)',
  'Heavy (B205, B212)'
];

// Combined export for easy access
export const WILDLIFE_DROPDOWN_OPTIONS = {
  SPECIES_OPTIONS,
  UTM_ZONE_OPTIONS,
  ANIMAL_DISTANCE_OPTIONS,
  ASPECT_OF_ANIMAL_OPTIONS,
  ELEVATION_OPTIONS,
  ANIMAL_REACTION_OPTIONS,
  ACTION_OPTIONS,
  INVENTORY_METHOD_OPTIONS,
  MACHINE_TYPE_OPTIONS
};
